import { PartnerPartnersStatusSummary } from 'vopay';
import { useCallback, useState } from 'react';
import { api } from '@/services/api.config';

/** Per-status counts of the partner accounts this partner created; the list filters are not applied. */
export default function useFetchPartnerPartnersStatusSummary() {
  const [fetchingStatusSummary, setFetchingStatusSummary] = useState(false);
  const [statusSummary, setStatusSummary] = useState<PartnerPartnersStatusSummary>();

  const fetchPartnerPartnersStatusSummary = useCallback(async () => {
    try {
      setFetchingStatusSummary(true);
      const res = await api.fetchPartnerPartnersStatusSummary();
      if (!res.Success) throw new Error(res.ErrorMessage);
      setStatusSummary(res);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setFetchingStatusSummary(false);
    }
  }, []);

  return { fetchingStatusSummary, statusSummary, fetchPartnerPartnersStatusSummary };
}
